import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import * as ReactDOM from 'react-dom/client';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import ja from 'date-fns/locale/ja';

const DatePeriodControl = ({ selectedDate, period, onChange }) => {
  const map = useMap();
  const controlRef = useRef(null);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!map || controlRef.current || rootRef.current) return;

    const customControl = L.control({ position: 'bottomleft' });
    customControl.onAdd = () => {
      const div = L.DomUtil.create('div', 'custom-dateperiod-control');
      div.style.zIndex = 1000;
      L.DomEvent.disableClickPropagation(div);
      controlRef.current = div;
      rootRef.current = ReactDOM.createRoot(div);
      return div;
    };

    customControl.addTo(map);
    return () => {
      if (map) map.removeControl(customControl);
      if (rootRef.current) {
        rootRef.current.unmount();
        rootRef.current = null;
      }
      controlRef.current = null;
    };
  }, [map]);

  useEffect(() => {
    if (!rootRef.current) return;
    rootRef.current.render(
      <Box
        sx={{
          width: 300,
          background: 'white',
          padding: 1.2,
          borderRadius: 2,
          boxShadow: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          userSelect: 'none',
        }}
      >
        <Typography variant="body2" sx={{ mb: 1 }}>
          表示日時を選択(UTC)
        </Typography>

        {/* 常時表示カレンダー */}
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={selectedDate ? new Date(selectedDate) : new Date()}
            onChange={(newValue) => {
              const isoDate = newValue.toISOString().slice(0, 10);
              onChange?.({ selectedDate: isoDate, period });
            }}
            slots={{ actionBar: () => null }}
          />
        </LocalizationProvider>

        {/* 午前午後切替 */}
        <ToggleButtonGroup
          color="primary"
          exclusive
          value={period}
          onChange={(e, newPeriod) => {
            if (newPeriod) onChange?.({ selectedDate, period: newPeriod });
          }}
          sx={{ mt: 1 }}
        >
          <ToggleButton value="am">Dsc</ToggleButton>
          <ToggleButton value="pm">Asc</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    );
  }, [selectedDate, period, onChange]);

  return null;
};

export default DatePeriodControl;
